export default {
    meta: {
        title: '踩点记录'
    }
};
